<div class="align-content-center" style="min-height: 500px">
  <div class="flex justify-content-center flex-wrap">
    <div class="flex align-items-center justify-content-center m-2">
      <p-card header="TERMINAL DE COMANDOS">
        <div class="formgroup" style="text-align: center;" (keyup.enter)="login()">
          <div class="field">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-user" />
              <input type="text" pInputText [(ngModel)]="user" placeholder="Usuario" />
            </p-iconField>
          </div>
          <div class="field">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-key" />
              <input type="password" pInputText [(ngModel)]="pass" placeholder="Contraseña" />
            </p-iconField>
          </div>
          <div class="field">
            <button pButton label="Acceder" (click)="login()" [loading]="loading"></button>
          </div>
        </div>
        <p-messages [(value)]="messages" [enableService]="false" [closable]="true" />
      </p-card>
    </div>
  </div>
</div>
